import { DefaultShopClass } from "../../../../../shop/frontend/web/js/classes/DefaultShopClass.js";

/** Класс от которого наследуются остальные классы */
export class DefaultClass extends DefaultShopClass {
	constructor() {
		super();
	}
}
